<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
  <div class="flex flex-row">
    <div class="basis-1/2">
      <drdp-title [title]="t('globalAnnouncements.title')"></drdp-title>
    </div>
    <div class="basis-1/2 mt-2">
      <div class="flex justify-end items-end">
        <drdp-btn
          (click)="openModal()"
          *drdpCheckPermission="Permission.AccessGlobalAnnouncements"
        >
          <i class="uil uil-plus"></i> {{ t('globalAnnouncements.addNew') }}
        </drdp-btn>
      </div>
    </div>
  </div>
  <drdp-container>
    <drdp-container color="lightBlue" additionClasses="w-full pb-5">
      <div class="px-5 p-5">
        <mat-checkbox
          class="rounded-checkboxes"
          color="primary"
          [checked]="searchAllStates"
          (change)="onAllStatesChange()"
        ></mat-checkbox>
        <label class="inline ml-1">{{ t('globalAnnouncements.allStates') }}</label>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-5 gap-3 items-start">
        <div class="col-span-1" [hidden]="searchAllStates">
          <drdp-select-state
            #stateSelect
            (state)="onStateChange($event)"
            [clear]="clearDropdowns"
            [required]="!searchAllStates"
          ></drdp-select-state>
        </div>
        <div class="col-span-1">
          <drdp-date-picker
            [label]="t('common.startDate')"
            [initialDate]="startDate?.value"
            [resetDate]="resetDates"
            (emitDate)="onDateChange('startDate', $event)"
          ></drdp-date-picker>
        </div>
        <div class="col-span-1">
          <drdp-date-picker
            [label]="t('common.endDate')"
            [initialDate]="endDate?.value"
            [resetDate]="resetDates"
            (emitDate)="onDateChange('endDate', $event)"
          ></drdp-date-picker>
          @if (searchForm.hasError('dateMismatch')) {
            <span class="text-red-500 text-xs">{{ t('common.invalidDateRange') }}</span>
          }
        </div>
        <div
          class="col-span-1 md:col-start-5 self-end justify-center md:justify-self-end"
        >
          <span class="flex justify-center">
            <drdp-btn additionalClasses="mr-4" (click)="onSearch()">{{
              t('common.search')
            }}</drdp-btn>
            <drdp-btn color="outline" (click)="onClear()" type="button">{{
              t('common.clear')
            }}</drdp-btn>
          </span>
        </div>
      </div>
    </drdp-container>
    <div class="px-5 pb-5 w-full overflow-x-auto">
      <drdp-add-edit-table
        [dataSource]="dataSource"
        [tableData]="tableData"
        [columns]="tableColumns"
        (editActionItem)="openModal($event)"
        (deleteActionItem)="deleteModal($event)"
      >
      </drdp-add-edit-table>
    </div>
  </drdp-container>

  <mat-paginator
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSize"
    [length]="totalData"
    [pageIndex]="pageIndex"
    (page)="paginateTable(false)"
    class="mb-12"
  >
  </mat-paginator>
</div>
</ng-container>
